<template>
    <section id="features"
        class="w-full py-16 md:py-24 lg:py-32 bg-gradient-to-b from-eblack-950 via-eblack-900 to-eblack-950 font-modulus flex items-center justify-center pb-20 relative overflow-hidden">

        <!-- Subtle background glow -->
        <div class="absolute top-0 left-1/4 w-96 h-96 bg-eorange-500/5 rounded-full blur-3xl pointer-events-none z-0"></div>
        <div class="absolute bottom-0 right-1/4 w-96 h-96 bg-eblue-500/5 rounded-full blur-3xl pointer-events-none z-0"></div>

        <div class="container px-4 md:px-6 relative z-10">
            <!-- Section Header -->
            <div class="text-center mb-16 space-y-4">
                <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-ewhite-50/5 border border-ewhite-50/10 text-eorange-400 text-xs font-semibold uppercase tracking-wider font-modulus">
                    {{ $t('marketing.auto.servicios_disponibles').split(' ')[0] }}
                </div>
                <h2 class="text-3xl md:text-5xl font-bold tracking-tighter text-ewhite-50 font-modulus-semi-bold">
                    {{ $t('features_section.title') }}
                </h2>
                <p class="mx-auto max-w-[700px] text-ewhite-300 md:text-lg leading-relaxed">
                    {{ $t('features_section.subtitle') }}
                </p>
            </div>

            <!-- Features Grid -->
            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
                <div
                    class="bg-ewhite-50/[0.03] backdrop-blur-md border border-ewhite-50/10 hover:bg-ewhite-50/[0.07] transition-all duration-300 hover:border-eorange-500/50 p-8 rounded-2xl shadow-lg hover:shadow-eorange-500/5 hover:-translate-y-1.5 group flex flex-col justify-between"
                    v-for="feature in features" :key="feature.id">
                    <div class="space-y-4">
                        <!-- Icon Badge with Glow -->
                        <div class="bg-eorange-500/10 w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:bg-eorange-500/20 group-hover:shadow-lg group-hover:shadow-eorange-500/10">
                            <div v-html="feature.icon"></div>
                        </div>

                        <!-- Title -->
                        <h3 class="text-ewhite-50 text-xl font-bold font-modulus-semi-bold group-hover:text-eorange-400 transition-colors duration-300">
                            {{ $t(feature.title) }}
                        </h3>

                        <!-- Description -->
                        <p class="text-ewhite-300 text-sm leading-relaxed font-modulus">
                            {{ $t(feature.description) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FeaturesSection',
    data() {
        return {
            features: [
                {
                    id: 1,
                    title: 'features_section.features.feature_1.title',
                    description: 'features_section.features.feature_1.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" /><path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" /></svg>`
                },
                {
                    id: 2,
                    title: 'features_section.features.feature_2.title',
                    description: 'features_section.features.feature_2.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" /></svg>`
                },
                {
                    id: 3,
                    title: 'features_section.features.feature_3.title',
                    description: 'features_section.features.feature_3.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" /><path d="M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M12 12l0 2.5" /></svg>`
                },
                {
                    id: 4,
                    title: 'features_section.features.feature_4.title',
                    description: 'features_section.features.feature_4.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 6m-5 0a5 3 0 1 0 10 0a5 3 0 1 0 -10 0" /><path d="M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" /><path d="M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" /><path d="M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" /><path d="M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" /><path d="M5 15v1m0 -8v1" /></svg>`
                },
                {
                    id: 5,
                    title: 'features_section.features.feature_5.title',
                    description: 'features_section.features.feature_5.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1" /></svg>`
                },
                {
                    id: 6,
                    title: 'features_section.features.feature_6.title',
                    description: 'features_section.features.feature_6.description',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-eorange-500"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" /><path d="M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M12 12l0 2.5" /></svg>`
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped></style>